import { MediaType } from '../../../../Chat.enum.ts';
import { tExtensionMap, tMediaMap } from './Thumbnail.types.ts';

export const mediaTypeMap: tMediaMap = {
  // Tipos de imagen
  'image/jpeg': MediaType.IMAGE,
  'image/png': MediaType.IMAGE,
  'image/gif': MediaType.IMAGE,
  'image/webp': MediaType.IMAGE,
  'image/svg+xml': MediaType.IMAGE,
  image: MediaType.IMAGE,

  // Tipos de video
  'video/mp4': MediaType.VIDEO,
  'video/webm': MediaType.VIDEO,
  'video/ogg': MediaType.VIDEO,
  'video/3gpp': MediaType.VIDEO,
  'video/3gpp2': MediaType.VIDEO,
  'video/quicktime': MediaType.VIDEO,
  'video/x-msvideo': MediaType.VIDEO,
  'video/x-ms-wmv': MediaType.VIDEO,
  'video/x-flv': MediaType.VIDEO,
  'video/x-matroska': MediaType.VIDEO,
  'video/x-m4v': MediaType.VIDEO,
  'video/x-3gpp': MediaType.VIDEO,
  'video/x-3gpp2': MediaType.VIDEO,

  // Tipos de audio
  'audio/mpeg': MediaType.AUDIO,
  'audio/ogg': MediaType.AUDIO,
  'audio/wav': MediaType.AUDIO,
  'audio/webm': MediaType.AUDIO,
  'audio/aac': MediaType.AUDIO,
  'audio/mp4': MediaType.AUDIO,

  // Tipos de documentos
  'application/pdf': MediaType.PDF,
  'application/msword': MediaType.DOCUMENT,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    MediaType.DOCUMENT,
  'application/vnd.ms-excel': MediaType.DOCUMENT,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    MediaType.DOCUMENT,
  'application/vnd.google-apps.document': MediaType.DOCUMENT,
  'application/vnd.google-apps.spreadsheet': MediaType.DOCUMENT,
  'application/xml': MediaType.DOCUMENT,

  // CSV
  'text/csv': MediaType.CSV,
};

export const fileExtensionMap: tExtensionMap = {
  '.csv': {
    extension: '.csv',
    mimeType: 'text/csv',
    mediaType: MediaType.CSV,
  },
  '.jpeg': {
    extension: '.jpeg',
    mimeType: 'image/jpeg',
    mediaType: MediaType.IMAGE,
  },
  '.jpg': {
    extension: '.jpg',
    mimeType: 'image/jpeg',
    mediaType: MediaType.IMAGE,
  },
  '.jfif': {
    extension: '.jfif',
    mimeType: 'image/jpeg',
    mediaType: MediaType.IMAGE,
  },
  '.jpe': {
    extension: '.jpe',
    mimeType: 'image/jpeg',
    mediaType: MediaType.IMAGE,
  },
  '.png': {
    extension: '.png',
    mimeType: 'image/png',
    mediaType: MediaType.IMAGE,
  },
  '.gif': {
    extension: '.gif',
    mimeType: 'image/gif',
    mediaType: MediaType.IMAGE,
  },
  '.webp': {
    extension: '.webp',
    mimeType: 'image/webp',
    mediaType: MediaType.IMAGE,
  },
  '.svg': {
    extension: '.svg',
    mimeType: 'image/svg+xml',
    mediaType: MediaType.IMAGE,
  },

  // Extensiones de video
  '.mp4': {
    extension: '.mp4',
    mimeType: 'video/mp4',
    mediaType: MediaType.VIDEO,
  },
  '.webm': {
    extension: '.webm',
    mimeType: 'video/webm',
    mediaType: MediaType.VIDEO,
  },
  '.mov': {
    extension: '.mov',
    mimeType: 'video/quicktime',
    mediaType: MediaType.VIDEO,
  },
  '.avi': {
    extension: '.avi',
    mimeType: 'video/x-msvideo',
    mediaType: MediaType.VIDEO,
  },
  '.wmv': {
    extension: '.wmv',
    mimeType: 'video/x-ms-wmv',
    mediaType: MediaType.VIDEO,
  },
  '.flv': {
    extension: '.flv',
    mimeType: 'video/x-flv',
    mediaType: MediaType.VIDEO,
  },
  '.m4v': {
    extension: '.m4v',
    mimeType: 'video/x-m4v',
    mediaType: MediaType.VIDEO,
  },
  '.3gp': {
    extension: '.3gp',
    mimeType: 'video/3gpp',
    mediaType: MediaType.VIDEO,
  },
  '.3g2': {
    extension: '.3g2',
    mimeType: 'video/3gpp2',
    mediaType: MediaType.VIDEO,
  },

  // Extensiones de audio
  '.mp3': {
    extension: '.mp3',
    mimeType: 'audio/mpeg',
    mediaType: MediaType.AUDIO,
  },
  '.ogg': {
    extension: '.ogg',
    mimeType: 'audio/ogg',
    mediaType: MediaType.AUDIO,
  },
  '.wav': {
    extension: '.wav',
    mimeType: 'audio/wav',
    mediaType: MediaType.AUDIO,
  },

  // Extensiones de documentos
  '.pdf': {
    extension: '.pdf',
    mimeType: 'application/pdf',
    mediaType: MediaType.PDF,
  },
  '.doc': {
    extension: '.doc',
    mimeType: 'application/msword',
    mediaType: MediaType.DOCUMENT,
  },
  '.docx': {
    extension: '.docx',
    mimeType:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    mediaType: MediaType.DOCUMENT,
  },
  '.xls': {
    extension: '.xls',
    mimeType: 'application/vnd.ms-excel',
    mediaType: MediaType.DOCUMENT,
  },
  '.xlsx': {
    extension: '.xlsx',
    mimeType:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    mediaType: MediaType.DOCUMENT,
  },
  '.gdoc': {
    extension: '.gdoc',
    mimeType: 'application/vnd.google-apps.document',
    mediaType: MediaType.DOCUMENT,
  },
  '.gsheet': {
    extension: '.gsheet',
    mimeType: 'application/vnd.google-apps.spreadsheet',
    mediaType: MediaType.DOCUMENT,
  },
  '.xml': {
    extension: '.xml',
    mimeType: 'application/xml',
    mediaType: MediaType.DOCUMENT,
  },
};
